<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Side Effect Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="6">
          <label>Code <require-sign /></label>
          <v-text-field
            v-model.trim="sideEffect.code"
            :error-messages="handleFieldErrors($v.sideEffect.code)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="6">
          <label>Name <require-sign /></label>
          <v-text-field
            v-model.trim="sideEffect.eng_name"
            :error-messages="handleFieldErrors($v.sideEffect.eng_name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="6">
          <label>Myanmar Name <require-sign /></label>
          <v-text-field
            v-model.trim="sideEffect.name"
            :error-messages="handleFieldErrors($v.sideEffect.name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="6"> </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="12">
          <label>Action Taken <require-sign /></label>
          <v-text-field
            v-model.trim="sideEffect.description"
            :error-messages="handleFieldErrors($v.sideEffect.description)"
            filled
            type="text"
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn @click.prevent="emitData" class="form-btn"> Submit </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "../notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },
  mixins: [ValidationMixin],
  props: {
    sideEffect: {
      type: Object,
      default: () => {
        return {
          name: null,
          eng_name: null,
          code: null,
          description: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    sideEffect: {
      name: {
        required,
      },
      eng_name: {
        required,
      },
      code: {
        required,
      },
      description: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    emitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.sideEffect.name,
          eng_name: this.sideEffect.eng_name,
          code: this.sideEffect.code,
          description: this.sideEffect.description,
        };

        this.sideEffect.id ? (data.id = this.sideEffect.id) : false;

        this.$emit("emitData", data);

        this.sideEffect.name = null;
        this.sideEffect.eng_name = null;
        this.sideEffect.code = null;
        this.sideEffect.description = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
